import React from "react";
import BreadcrumbDetailed from "components/Common/BreadcrumbDetailed";
import AdsSpaceSectionMainTheme2 from "./AdsSpaceSectionMainTheme2";
import AdsSpaceSectionTheme2 from "./AdsSpaceSectionTheme2";
import { useSelector } from "react-redux";
import ProductListingPageAction from "components/ProductListingPageNew/ActionsNew";
import SidebarNew from "components/ProductListingPageNew/SidebarNew";
import "./catering-theme2.scss";
import CateringProductListTheme2 from "./CateringProductListTheme2";
import { useGetCateringTree } from 'hooks/useGetCateringTree';
import { useGetCateringProducts } from 'hooks/useGetCateringProducts';

const CateringTheme2 = () => {

  const {shopByDepartmentSelectedOptionName} = useSelector(s => s.common)
  const breadcrumbList = [
    { lable: shopByDepartmentSelectedOptionName || "Catering & meals", link: "", searchTag: "" },
  ];
  const categoryadsSection = useSelector(({ cateringAndMeal }) => cateringAndMeal.categorySection);

  const { cateringListTotalRecords } = useSelector(({ cateringAndMeal }) => cateringAndMeal);

  const {data: cateringDepartmentTree} = useGetCateringTree()
  useGetCateringProducts()

  return (
    <div className="catering-page2">
      <BreadcrumbDetailed breadcrumbList={breadcrumbList} title={""} />
      <AdsSpaceSectionMainTheme2 adsDetails={categoryadsSection} />
      <div className="container">
      <SidebarNew
        departmentTree={cateringDepartmentTree}
        isCateringDepartment={true}
        redirectBaseUrl="catering-meal"
        querySearchKey="category_ids"
      />
        <div className={`catering-page-wrapper show-catering`}>
          <div className="listing-page-wrapper-items">
            <AdsSpaceSectionTheme2
              adsDetails={categoryadsSection}
              department={cateringDepartmentTree?.[0]?.text}
            />
            <>
              <ProductListingPageAction
                pageLimit={20}
                setPageLimit={() => { }}
                productListByDepartmentTotalCount={cateringListTotalRecords}
                departmentTree={cateringDepartmentTree}
                iftOptionList={[]}
                redirectBaseUrl="catering-meal"
                querySearchKey="category_ids"
              />
              <CateringProductListTheme2 />
            </>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CateringTheme2;
